import { render } from "./systemConfig.vue?vue&type=template&id=1851e1c3&scoped=true"
import script from "./systemConfig.vue?vue&type=script&lang=js"
export * from "./systemConfig.vue?vue&type=script&lang=js"

import "./systemConfig.vue?vue&type=style&index=0&id=1851e1c3&lang=scss&scoped=true"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1851e1c3"]])

export default __exports__